import { Link } from 'react-router-dom';
import './ProfileMenu.css';
import { useLocation } from 'react-router-dom';
import { Container } from 'reactstrap';
import { useTranslation } from 'react-i18next';

function ProfileMenu() {
  const location = useLocation();
  const { t } = useTranslation();

  const menuItems = [
    { to: "/profile", label: t("profile.menu.profile") },
    { to: "/ad_balance", label: t("profile.menu.balance") },
    { to: "/my_properties", label: t("profile.menu.my_properties") },
    { to: "/wish_requests", label: t("profile.menu.wishlist") },
    { to: "/favorites", label: t("profile.menu.favorites") },
  ];

  return (
    <div className='profile-menu bg-light'>
      <Container>
        <div className="profile-menu-container">
          {menuItems.map(item => (
            <Link
              key={item.to}
              to={item.to}
              className={`text-primary d-flex align-items-center${location.pathname === item.to ? ' active' : ''}`}
            >
              {item.label}
            </Link>
          ))}
        </div>
      </Container>
    </div>
  );
}

export default ProfileMenu;